import unProtectedApiService from '@/core/services/unProtectedApiService.ts'
import { validateSchemaAsync } from '@/core/utils/safeSchemaValidations.ts'
import {
  LoginValidateCodeResp,
  loginValidateCodeSchema
} from '@/modules/security/login/services/apiValidationSchemas.ts'
import gestionApiService from '@/core/services/gestionApiService.ts'
import { LoginData } from '@/modules/security/login/types/LoginData.ts'

const login = ({ email, password, longitude, latitude }: LoginData) =>
  unProtectedApiService.httpPOST<void>('login_check', {
    username: email,
    password,
    latitude,
    longitude
  })

const validateCode = (code: string, email: string) =>
  validateSchemaAsync(
    loginValidateCodeSchema,
    unProtectedApiService.httpPOST<LoginValidateCodeResp>('validate-code', {
      code,
      email
    })
  )

const logout = () => gestionApiService.httpPOST<void>('logout')

const loginService = {
  login,
  validateCode,
  logout
}

export default loginService
